function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 6h3s4.23-3.084 6.587-3.084C25.944 2.916 27 3.643 27 6c0 13 1 32 1 35 0 2.56 3.595 3.079 3.49.063C31 27 35 25 37.523 23L45 31c-5.276.174-2.162 22.685-15.42 21.415-5.233-.501-7.103-4.997-7.012-11.5.162-11.633.546-30.905.675-32.924.17-2.68-2.34-2.332-4.243-.992-1.693.156-5-1-5-1z"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.005 21a.998.998 0 011.414.034l8.61 9.028a.998.998 0 01-.034 1.414.998.998 0 01-1.413-.033l-8.61-9.03A.998.998 0 0137.004 21z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.1,
  cy: 18.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.1,
  cy: 22.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.1,
  cy: 26.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25.1,
  cy: 30.5,
  r: 0.5
})));

var SvgSaxophone = function SvgSaxophone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaxophone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Saxophone.e5fbfa46.svg";
export { ForwardRef as ReactComponent };